<app-dialog-container>
  <mat-dialog-content class="dialogContent">
    <h1 mat-card-title>{{ title }}</h1>
    <div fxLayout="column" fxLayoutGap="10">
      <!-- FILTRO -->
      <div fxFlex="50px">
        <div fxLayout="row" *ngIf="hasFilter" fxFlexFill fxLayoutAlign="space-between baseline">
          <div fxFlex="100">
            <mat-form-field *ngIf="!hideFilter">
              <input
                matInput
                #input
                (keyup)="applyFilter($event)"
                (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
                (ngModelChange)="keyboardService.onInputChange(input.value, input)"
                placeholder="Pesquisar" />
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- TABELA -->
      <div fxFlex class="panel">
        <div fxLayout="column" fxFill>
          <div fxFlex="90">
            <section
              class="sec-table mat-elevation-z2"
              [ngClass.gt-xs]="'sec-table-xs'"
              [ngClass.gt-md]="'sec-table-md'"
              [ngClass.gt-lg]="'sec-table-lg'"
              tabindex="0">
              <table mat-table [dataSource]="dataSource">
                <!-- Coluna Módulo -->
                <ng-container matColumnDef="module">
                  <th mat-header-cell *matHeaderCellDef>
                    MÓDULO
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.module }}
                  </td>
                </ng-container>

                <!-- Coluna SendToPartner -->
                <ng-container matColumnDef="sendToPartner">
                  <th mat-header-cell *matHeaderCellDef>
                    PARCEIRO
                    <mat-slide-toggle
                      color="primary"
                      [checked]="isAllSelectedFor('sendToPartner')"
                      (change)="toggleAll('sendToPartner', $event.checked)"
                      style="margin-left: 8px; vertical-align: middle;">
                    </mat-slide-toggle>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-slide-toggle color="primary" [(ngModel)]="element.sendToPartner"></mat-slide-toggle>
                  </td>
                </ng-container>

                <!-- Coluna SendToCustomer -->
                <ng-container matColumnDef="sendToCustomer">
                  <th mat-header-cell *matHeaderCellDef>
                    CLIENTE
                    <mat-slide-toggle
                      color="primary"
                      [checked]="isAllSelectedFor('sendToCustomer')"
                      (change)="toggleAll('sendToCustomer', $event.checked)"
                      style="margin-left: 8px; vertical-align: middle;">
                    </mat-slide-toggle>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-slide-toggle color="primary" [(ngModel)]="element.sendToCustomer"></mat-slide-toggle>
                  </td>
                </ng-container>

                <!-- Coluna SendToUser -->
                <ng-container matColumnDef="sendToUser">
                  <th mat-header-cell *matHeaderCellDef>
                    USUÁRIO
                    <mat-slide-toggle
                      color="primary"
                      [checked]="isAllSelectedFor('sendToUser')"
                      (change)="toggleAll('sendToUser', $event.checked)"
                      style="margin-left: 8px; vertical-align: middle;">
                    </mat-slide-toggle>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-slide-toggle color="primary" [(ngModel)]="element.sendToUser"></mat-slide-toggle>
                  </td>
                </ng-container>

                <!-- Coluna EmailEnabled e Template -->
                <ng-container matColumnDef="emailEnabled">
                  <th mat-header-cell *matHeaderCellDef>
                    EMAIL ATIVADO
                    <mat-slide-toggle
                      color="accent"
                      [checked]="isAllSelectedFor('emailEnabled')"
                      (change)="toggleAll('emailEnabled', $event.checked)"
                      style="margin-left: 8px; vertical-align: middle;">
                    </mat-slide-toggle>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-slide-toggle color="accent" [(ngModel)]="element.emailEnabled"></mat-slide-toggle>
                    <ng-container *ngIf="element.emailEnabled">
                      <mat-form-field appearance="outline" style="width: 150px; margin-left: 8px;">
                        <mat-label>Template</mat-label>
                        <mat-select [(ngModel)]="element.selectedTemplate">
                          <mat-option *ngFor="let template of element.availableTemplates" [value]="template">
                            {{ template }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <!-- Botão para upload de novo template -->
                      <button mat-icon-button (click)="triggerFileInput(element)" title="Adicionar template customizado">
                        <mat-icon>add</mat-icon>
                      </button>
                    </ng-container>
                  </td>
                </ng-container>

                <!-- Header e Linhas -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
              <mat-paginator [length]="length"
                             [pageSize]="pageSize"
                             [pageSizeOptions]="pageSizeOptions"
                             (page)="pageEvent($event)">
              </mat-paginator>
            </section>
          </div>
        </div>
      </div>
      <!-- OUTRAS OPCOES -->
      <div fxFlex="12"></div>
    </div>
  </mat-dialog-content>

  <app-dialog-save-close closeText="SAIR"
                           saveText="APLICAR"
                           [closeOnSave]="false"
                           (onSave)="confirm()">
  </app-dialog-save-close>
</app-dialog-container>
